// packages block
import { useHistory } from "react-router";
import { Dialog } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useReducer, useState, useEffect } from "react";
// common block
import "./style.css";
import { preaddStyles } from "./styles";
import { FormButton } from "../form/button";
import { AddInvoiceForm } from "./addInvoiceForm";
import { PreDialogHeader } from "./preDialogHeader";
// constants, theme, utils and api block
import { setAlert } from "../../redux/reducers/alert";
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../theme";
import { validateAddInvoiceForm } from "../../util/validation";
import { addInvoice, updateInvoice, addBalance } from "../../api/invoices";

export const AddInvoiceDialog = ({
  open,
  handleClose,
  title,
  selectedForm,
  successCallback,
  isEditedItem,
  isGenratedItem,
  editedSuccessCallback,
  fetchStudents,
}) => {
  const classes = preaddStyles();
  let local = JSON.parse(localStorage.getItem("notify"));
  // var locals = JSON.parse(localStorage.getItem("persist:root"));
  // locals = JSON.parse(locals.user);

  local = local || [];
  // var schoolId;
  const [
    {
      studentId,
      type,
      term,
      amount,
      firstName,
      lastName,
      grade,
      studentRegNo,
      invoiceId,
      feeMonth,
      dueDate,
      schoolFee,
      otherFee,
      studentInfoo,
      selectedFormVal,
      balanceVal,
      schoolId,
      file,
    },
    setData,
  ] = useReducer((state, newState) => ({ ...state, ...newState }), {
    studentId: 0,
    type: 0,
    term: 0,
    amount: "",
    invoiceId: "",
    feeMonth: "",
    dueDate: "",
    schoolFee: "",
    otherFee: 0,
    schoolId: 0,
    studentRegNo: 0,
    firstName: "",
    lastName: "",
    grade: "",
    balanceVal: "",
    studentInfoo: {},
    selectedFormVal: "",
    file: "",
  });
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function getFee(fetchStudents) {
    return fetchStudents ? fetchStudents : "";
  }

  const handleChange = (prop, index) => (event) => {
    setData({
      [prop]: event.target.value,
    });
    if (getFee(fetchStudents) != "") {
      setData({
        firstName: isEditedItem.firstName,
        lastName: isEditedItem.lastName,
        grade: isEditedItem.grade,
        studentRegNo: isEditedItem.studentRegNo,
        schoolId: isEditedItem.schoolId,
        studentId: isEditedItem.id,
        file: isEditedItem.file,
        amount: isEditedItem.total_balance_amount,
        // dueDate: isEditedItem?.dueDate,
      });
    }

    if (errors.indexOf(prop) > -1) {
      const updatedErrors = [...errors];
      updatedErrors.splice(errors.indexOf(prop), 1);
      setErrors(updatedErrors);
    }
  };
  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const resetData = () => {
    setData({
      studentId: 0,
      type: 0,
      term: 0,
      amount: 0,
      invoiceId: 0,
      feeMonth: "",
      dueDate: "",
      schoolFee: "",
      otherFee: 0,
      schoolId: 0,
      studentRegNo: "",
      firstName: "",
      lastName: "",
      grade: "",
      file,
    });

    setLoading(false);
  };

  const close = () => {
    resetData();
    handleClose();
  };

  useEffect(() => {
    if (isEditedItem) {
      setData({
        studentId: isEditedItem.studentId
          ? isEditedItem.studentId.toString()
          : "",
        type: isEditedItem.type ? isEditedItem.type.toString() : 0,
        term: isEditedItem.term ? isEditedItem.term.toString() : 0,
        amount: isEditedItem.amount ? isEditedItem.amount.toString() : 0,

        invoiceId: isEditedItem.invoiceId
          ? isEditedItem.invoiceId.toString()
          : "",

        feeMonth: isEditedItem.feeMonth ? isEditedItem.feeMonth.toString() : "",
        dueDate: isEditedItem.dueDate ? isEditedItem.dueDate : "",

        schoolFee: isEditedItem.schoolFee
          ? isEditedItem.schoolFee.toString()
          : "",

        otherFee: isEditedItem.otherFee ? isEditedItem.otherFee.toString() : 0,

        schoolId: isEditedItem.schoolId ? isEditedItem.schoolId.toString() : 0,
        studentRegNo: isEditedItem.studentRegNo
          ? isEditedItem.studentRegNo.toString()
          : "",

        firstName: isEditedItem.firstName
          ? isEditedItem.firstName.toString()
          : "",

        lastName: isEditedItem.lastName ? isEditedItem.lastName.toString() : "",

        grade: isEditedItem.grade ? isEditedItem.grade.toString() : "",
        file: isEditedItem.file ? isEditedItem.file.toString() : "",
      });
    }
  }, [isEditedItem]);

  const addBalanceHandler = async () => {
    const validationResponse = validation(false);
    if (validationResponse.length > 0) {
      setErrors(validationResponse);
      return;
    }

    try {
      setLoading(true);
      const payload = {
        studentId: parseInt(studentId, 10),
        balanceVal,
        dueDate,
        schoolId,
        // studentRegNo,
        // firstName,
        // lastName,
        // grade,
        // status: 1,
        // file,
      };
      if (dueDate !== "") {
        payload.dueDate = dueDate;
      }
      const checkData = await addBalance(payload, user.token);

      if (checkData) {
        showSuccessAlert(t("text_balance_updated_successfully"));
        resetData();
      }
      setLoading(false);
      window.location.reload();
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || "Error in updating invoice. Please try again"
      );
    }
  };

  const validation = (value) => validateAddInvoiceForm(balanceVal, dueDate);

  useEffect(() => {
    setData({
      selectedFormVal: selectedForm,
    });
  }, [selectedForm]);

  return (
    <Dialog
      className={classes.root}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div
        className={classes.mainContainer}
        style={{ borderRadius: "111px !important" }}
      >
        <PreDialogHeader
          title={title}
          handleClose={handleClose}
          backbut={true}
        />
        <div className={classes.dropContainer}>
          <AddInvoiceForm
            selectedForm={selectedFormVal}
            studentId={studentId}
            type={type}
            term={term}
            amount={amount}
            balanceVal={balanceVal}
            feeMonth={feeMonth}
            dueDate={dueDate}
            schoolFee={schoolFee}
            otherFee={otherFee}
            schoolId={schoolId}
            studentRegNo={studentRegNo}
            file={file}
            firstName={firstName}
            lastName={lastName}
            grade={grade}
            handleChange={handleChange}
            errors={errors}
            studentInfo={studentInfoo}
          />
        </div>

        <div className={classes.addSchooldialogFooter}>
          <div className={classes.footerButton}>
            <FormButton
              title={t("text_cancel")}
              backgroundColor={ORANGE_TWO}
              borderColor={ORANGE_TWO}
              titleColor={WHITE}
              hoverBackgroundColor={WHITE}
              hoverBorderColor={ORANGE_TWO}
              hoverTitleColor={ORANGE_TWO}
              onClickHandler={close}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              style={{ fontSize: "0.8vw", fontWeight: "700" }}
            />
          </div>
          <div className={classes.footerButton}>
            <FormButton
              loading={loading}
              title={t("text_confirm")} //selectedFormVal === "balance" ? "confirm balance" :
              onClickHandler={
                user.role === "manager" &&
                selectedFormVal === "balance" &&
                addBalanceHandler
                // : isEditedItem
                //   ? editInvoiceHandler
                //   : addInvoiceHandler
              }
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              backgroundColor={BLUE_EIGHT}
              titleColor={WHITE}
              hoverTitleColor={BLUE_EIGHT}
              hoverBackgroundColor={WHITE}
              hoverBorderColor={BLUE_EIGHT}
              style={{ fontSize: "0.8vw", fontWeight: "700" }}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
